import {
  Radio as MantineRadio,
  RadioProps as MantineRadioProps,
  RadioIconProps,
} from '@mantine/core';
import { forwardRef } from 'react';

import styles from './Radio.module.css';

export type RadioProps = Omit<
  MantineRadioProps,
  'variant' | 'color' | 'styles' | 'classNames' | 'style' | 'size' | 'readOnly'
> & {
  isReadOnly?: boolean;
};

const ReadOnlyCheckIcon = ({ style, ...others }: RadioIconProps) => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    {...others}
  >
    <path
      d="M2.5 6.5L4.875 8.875L9.625 4.125"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ isReadOnly, ...props }, ref) => {
    return (
      <MantineRadio
        ref={ref}
        unstyled
        readOnly={isReadOnly}
        icon={isReadOnly ? ReadOnlyCheckIcon : undefined}
        classNames={{
          root: styles.root,
          radio: styles.radio,
          icon: styles.icon,
          inner: styles.inner,
          body: styles.body,
          labelWrapper: styles.labelWrapper,
          label: styles.label,
          description: styles.description,
          error: styles.error,
        }}
        wrapperProps={{
          'data-readonly': isReadOnly,
        }}
        {...props}
      />
    );
  }
);

Radio.displayName = 'Radio';
